import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {

  message = 'Are you sure to delete?';
  confirmButtonText = 'Yes';
  cancelButtonText = 'No';
  textBoxMessage: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
      if (data){
    this.message = data.message || this.message;
    if (data.buttonText) {
      this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
    }
      }
  }

  onConfirmClick(): void {
    if (this.data?.showTextBox) {
      this.dialogRef.close({textBox: this.textBoxMessage, buttonStatus: 'yes'});
    } else {
      this.dialogRef.close(true);
    }
  }

  onChangeTextBox(event: any): void {
    this.textBoxMessage = event.target.value;
  }

  closeDirectly(isDirectlyClose: string = 'no'): void {
    this.dialogRef.close(isDirectlyClose);
  }
}
